<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'transport-wait-exportDeclaration',
  components: {
    PageTable,
  },
}
</script>
